import React from "react";
import { BrandMark } from "../brand/BrandMark";
import { CourtLines } from "../brand/CourtLines";
import { navLinks } from "../../data/content";
import { PREVIEW_MODE } from "../../data/siteConfig";
const footerLinks = [...navLinks, {
  label: "See the bundle",
  href: "#offer"
}];
export function SiteFooter() {
  return <footer className="relative overflow-hidden border-t-[3px] border-cyan bg-navy-900 text-ice" data-id="element-37" data-mp="xzmgatzr0tu2">
      <CourtLines className="pointer-events-none absolute -right-40 -top-40 h-[560px] w-[560px] text-cyan/[0.06]" data-id="element-38" data-mp="1lpqgerdqabgb" />
      <div className="container-x relative pb-28 pt-16 md:pb-12 lg:pt-20" data-id="element-39" data-mp="1qmqot8y1vqal">
        <div className="grid gap-12 border-b border-white/10 pb-12 lg:grid-cols-12" data-id="element-40" data-mp="1cmpel2vwb6ig">
          <div className="lg:col-span-8" data-id="element-41" data-mp="1gokmiq8c0i57">
            <a href="#top" className="inline-flex items-center gap-3" data-id="element-42" data-mp="1gnj2vxd92nbv">
              <BrandMark className="h-10 w-10 text-ice lg:h-12 lg:w-12" data-id="element-43" data-mp="17slnhwlbx5t" />
              <span className="font-display text-[clamp(1.9rem,7vw,4rem)] font-extrabold leading-none" data-id="element-44" data-mp="5aoyerzg8z1u">
                FloorHockey<span className="text-cyan" data-id="element-45" data-mp="1xwjnmnb35tab">ClassReady</span>
              </span>
            </a>
            <p className="mt-6 max-w-[32rem] leading-relaxed text-ice/75" data-id="element-46" data-mp="1sxfhk5jgkbo7">
              An original, done-for-you school floor-hockey unit for teachers of ages 8–12. Open it, look, and teach.
            </p>
          </div>
          <nav aria-label="Footer" className="lg:col-span-4 lg:justify-self-end" data-id="element-47" data-mp="22t0evqdl0nrm">
            <ul className="grid grid-cols-2 gap-x-8 gap-y-3 lg:grid-cols-1" data-id="element-48" data-mp="2gt1phxjnf9ka">
              {footerLinks.map(link => <li key={link.href} data-id="element-49" data-mp="2buzwajsidtv3">
                  <a href={link.href} className="whitespace-nowrap text-[15px] font-semibold text-ice/80 transition-colors duration-150 hover:text-cyan" data-id="element-50" data-mp="2qjwdp7gggj8d">
                    {link.label}
                  </a>
                </li>)}
            </ul>
          </nav>
        </div>
        <div className="flex flex-col gap-3 pt-8 text-[13px] text-ice/65 sm:flex-row sm:items-center sm:justify-between" data-id="element-51" data-mp="2unc6fspelzfs">
          <p data-id="element-52" data-mp="1s68nycuwu8v6">© 2026 FloorHockeyClassReady{PREVIEW_MODE && " · Preview design — checkout not open"}</p>
          <p className="text-[12px] text-ice/55" data-id="element-53" data-mp="1x5bopl3uxsxc">by StockDigital</p>
        </div>
      </div>
    </footer>;
}